import i18n from "@/i18n";

function processDetails(distribution) {
    if (distribution.distribution_details) {
        var category_code = '';
        var cat_num_sum = 0;
        var cat_sum = 0;
        distribution.distribution_details.forEach((detail) => {
            if (detail.stock_unit_rate == detail.distribution_unit_rate)
            detail.stock_unit_num = i18n.t("Stock.stockQuantity", [
                detail.distribution_num,
                detail.stock_unit,
            ]);
            else {
            if (!detail.default_distribution_num)
                detail.default_distribution_num =
                detail.distribution_num * detail.distribution_unit_rate;
            var bigUnitNum = Math.floor(
                detail.default_distribution_num / detail.stock_unit_rate
            );
            var leftNum =
                detail.default_distribution_num % detail.stock_unit_rate;
            if (leftNum)
                detail.stock_unit_num = i18n.t(
                "Stock.stockQuantityWithMultipleUnits",
                [bigUnitNum, detail.stock_unit, leftNum, detail.default_unit]
                );
            else
                detail.stock_unit_num = i18n.t("Stock.stockQuantity", [
                bigUnitNum,
                detail.stock_unit,
                ]);
            }
            detail.sum = detail.price * detail.distribution_num;
            
            if(category_code != detail.category_code) {
                category_code = detail.category_code;
                cat_num_sum = detail.distribution_num;
                cat_sum = detail.sum;
            } else {
                cat_num_sum += detail.distribution_num;
                cat_sum += detail.sum;
            }
            detail.cat_num_sum = cat_num_sum;
            detail.cat_sum = cat_sum;
        });
    }
    return distribution;
}

export default {
    processDetails
};